import { render, staticRenderFns } from "./exportProjectPopup.vue?vue&type=template&id=63ba7dca&scoped=true"
import script from "./exportProjectPopup.vue?vue&type=script&lang=js"
export * from "./exportProjectPopup.vue?vue&type=script&lang=js"
import style0 from "./exportProjectPopup.vue?vue&type=style&index=0&id=63ba7dca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ba7dca",
  null
  
)

export default component.exports